import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

const SEG_STYLE = {
  fan: { bg: "rgba(52,211,153,.15)", color: "#34d399", label: "Fan" },
  da_crescere: { bg: "rgba(125,211,252,.15)", color: "#7dd3fc", label: "Da crescere" },
  trappola: { bg: "rgba(251,191,36,.15)", color: "#fbbf24", label: "Trappola" },
  zavorra: { bg: "rgba(251,113,133,.15)", color: "#fb7185", label: "Zavorra" },
};

const COLS = [
  { key: "annual_margin", label: "Margine €" },
  { key: "annual_revenue", label: "Fatturato €" },
  { key: "margin_per_hour", label: "Margine €/h" },
  { key: "hours", label: "Ore" },
  { key: "docs", label: "Registrazioni" },
  { key: "messages", label: "Mail+WA" },
  { key: "appts", label: "Appuntamenti" },
  { key: "frequency", label: "Freq./mese" },
  { key: "years_active", label: "Anni" },
  { key: "referrals", label: "Portati" },
];

const eur = (v) => (v == null ? "—" : Number(v).toLocaleString("it-IT", { maximumFractionDigits: 0 }));

export default function ClientValue() {
  const [data, setData] = useState(null);
  const [sortBy, setSortBy] = useState("annual_margin");

  useEffect(() => { api.get("/stats/clients-value").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="page"><p className="muted">Caricamento…</p></div>;

  const rows = [...(data.clients || [])].sort((a, b) => (b[sortBy] ?? -Infinity) - (a[sortBy] ?? -Infinity));
  const diamond = rows.find((r) => r.diamond);

  return (
    <div className="page">
      <h1 className="page-title">Valore clienti</h1>
      <p className="muted">Clicca una colonna per ordinare. 💎 = Cliente Diamante: il margine più alto con meno ore.</p>

      {diamond && (
        <div className="panel" style={{ borderColor: "#7dd3fc", boxShadow: "var(--halo-active)" }} data-testid="diamond-client">
          <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
            <span style={{ fontSize: 34 }}>💎</span>
            <div>
              <strong style={{ fontSize: 17 }}><Link to={`/aziende/${diamond.id}`}>{diamond.name}</Link></strong>
              <div className="muted" style={{ fontSize: 13 }}>
                Cliente Diamante {diamond.reference_year || ""} — margine {eur(diamond.annual_margin)} € in sole {diamond.hours} ore
                ({eur(diamond.margin_per_hour)} €/ora)
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="panel" style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {Object.entries(data.counts || {}).map(([k, v]) => (
          <span key={k} className="pill" style={{ background: SEG_STYLE[k]?.bg, color: SEG_STYLE[k]?.color }}>{SEG_STYLE[k]?.label}: {v}</span>
        ))}
      </div>

      <div className="panel" style={{ overflowX: "auto" }}>
        <table data-testid="clients-value-table">
          <thead>
            <tr>
              <th>Cliente</th>
              {COLS.map((c) => (
                <th key={c.key} style={{ cursor: "pointer", whiteSpace: "nowrap", color: sortBy === c.key ? "var(--primary)" : undefined }}
                  onClick={() => setSortBy(c.key)} data-testid={`sort-${c.key}`}>
                  {c.label} {sortBy === c.key ? "▼" : ""}
                </th>
              ))}
              <th>Segmento</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} style={r.diamond ? { background: "rgba(125,211,252,.08)" } : undefined}>
                <td style={{ whiteSpace: "nowrap" }}>{r.diamond ? "💎 " : ""}<Link to={`/aziende/${r.id}`}>{r.name}</Link></td>
                <td><strong>{eur(r.annual_margin)}</strong></td>
                <td>{eur(r.annual_revenue)}</td>
                <td>{r.margin_per_hour != null ? eur(r.margin_per_hour) : "—"}</td>
                <td>{r.hours || "—"}</td>
                <td>{r.docs || "—"}</td>
                <td>{r.messages ? `${r.messages}${r.wa ? ` (${r.wa} WA)` : ""}` : "—"}</td>
                <td>{r.appts || "—"}</td>
                <td>{r.frequency || "—"}</td>
                <td>{r.years_active}</td>
                <td>{r.referrals || "—"}</td>
                <td><span className="pill" style={{ background: SEG_STYLE[r.segment]?.bg, color: SEG_STYLE[r.segment]?.color }}>{SEG_STYLE[r.segment]?.label || r.segment}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
